/* src/app/webtree-website/gen-ai-loader/gen-ai-loader.component.scss */
.genai-text {
  background-image:
    linear-gradient(
      to bottom,
      #9f38f0 0%,
      #e54f7a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
span.mr-3 {
  width: 16px;
  text-align: center;
}
.mat-progress-bar {
  height: 8px !important;
}
.mat-progress-bar-buffer {
  background-color: white !important;
}
.mat-progress-bar-fill::after {
  background-image:
    linear-gradient(
      to right,
      #e24e7f,
      #c845ab) !important;
  border-radius: 100px !important;
}
.text-f2f2 {
  color: #f2f2f2;
}
.progress-bar {
  width: 0;
  animation: progress 5s ease-in-out forwards;
  background-image:
    linear-gradient(
      to right,
      #e24e7f,
      #c845ab);
  height: 8px;
}
@keyframes progress {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.progress {
  background: #fff5f8;
}
/*# sourceMappingURL=gen-ai-loader.component-DGXWJO5W.css.map */
